import { VisualizationPath } from './types';

export const PATH_KEYS = {
    HAND_PATH: 'HAND_PATH',
    CLUB_PATH: 'CLUB_PATH',
} as const;

export const PATHS: Record<string, VisualizationPath> = {
    [PATH_KEYS.HAND_PATH]: {
        label: 'Hand path',
        type: 'path',
        id: PATH_KEYS.HAND_PATH,
    },
    [PATH_KEYS.CLUB_PATH]: {
        label: 'Club path',
        type: 'path',
        id: PATH_KEYS.CLUB_PATH,
    },
};

export const PATHS_LIST = Object.keys(PATHS);
